import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import {
  getHelperTextProps,
  HelperTextPopover,
} from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import { FormFieldProps } from './FormField';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export function FormFieldSelect<T>({
  inputProps,
  label,
  error,
  value,
  options,
  placeholder,
  disabled,
  onChange,
  inline,
  helperText,
}: FormFieldProps<T>) {
  if (!options) {
    throw new Error('options is required for select type');
  }

  const { popoverProps } = getHelperTextProps({
    helperText,
    label,
  });

  return (
    <DefaultFormFieldLayout
      inline={inline}
      label={label}
      error={error}
      inputId={inputProps.id}
    >
      <div className="flex items-center gap-2" data-testid={inputProps.id}>
        <Select
          id={inputProps.id}
          selected={value as SelectOption}
          options={options}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(newOption?: SelectOption) =>
            typeof onChange === 'function' && onChange(newOption)
          }
          error={error}
        />
        {popoverProps && <HelperTextPopover {...popoverProps} />}
      </div>
    </DefaultFormFieldLayout>
  );
}
